import React from 'react';

export const TroubleshootingSection = ({ isSuperAdmin }) => (
  <>
    <h3 className="text-lg font-semibold mb-3">Common Issues & Solutions</h3>

    <div className="space-y-4">
      <div className="border-l-4 border-red-400 pl-4">
        <h4 className="font-semibold text-red-900 mb-2">Insufficient Balance</h4>
        <p className="text-sm mb-2"><strong>Problem:</strong> Cannot submit claim due to low family balance.</p>
        <p className="text-sm"><strong>Solution:</strong> {isSuperAdmin ? 'Contact system admin to increase family allotment in Admin Panel → Families tab.' : 'Contact your system administrator to increase the family allotment.'}</p>
      </div>

      <div className="border-l-4 border-orange-400 pl-4">
        <h4 className="font-semibold text-orange-900 mb-2">Patient Not Found</h4>
        <p className="text-sm mb-2"><strong>Problem:</strong> Search returns no results.</p>
        <p className="text-sm"><strong>Solutions:</strong></p>
        <ul className="list-disc list-inside text-sm ml-4 mt-1">
          <li>Verify serial number or family ID is correct</li>
          <li>Check if patient is suspended (they will still appear but show suspended status)</li>
          <li>{isSuperAdmin ? 'Verify patient exists in Admin Panel → Members tab' : 'Contact system administrator to verify patient exists'}</li>
        </ul>
      </div>

      <div className="border-l-4 border-yellow-400 pl-4">
        <h4 className="font-semibold text-yellow-900 mb-2">Cannot Submit Claim for Suspended Patient</h4>
        <p className="text-sm mb-2"><strong>Problem:</strong> Error when trying to submit claim.</p>
        <p className="text-sm"><strong>Solution:</strong> Patient or family is suspended. {isSuperAdmin ? 'Go to Admin Panel and unsuspend the patient/family if they should be active.' : 'Contact system administrator to unsuspend the patient.'}</p>
      </div>

      <div className="border-l-4 border-blue-400 pl-4">
        <h4 className="font-semibold text-blue-900 mb-2">Price List Item Not Found</h4>
        <p className="text-sm mb-2"><strong>Problem:</strong> Cannot find a medical service in price list.</p>
        <p className="text-sm"><strong>Solution:</strong> {isSuperAdmin ? 'Add the item in Admin Panel → Price Lists tab for your hospital.' : 'Contact system administrator to add the service to your hospital\'s price list.'}</p>
      </div>

      {isSuperAdmin && (
        <>
          <div className="border-l-4 border-purple-400 pl-4">
            <h4 className="font-semibold text-purple-900 mb-2">Bulk Upload Failed</h4>
            <p className="text-sm mb-2"><strong>Problem:</strong> CSV upload shows error.</p>
            <p className="text-sm"><strong>Solutions:</strong></p>
            <ul className="list-disc list-inside text-sm ml-4 mt-1">
              <li>Download and use the provided CSV template</li>
              <li>Ensure no duplicate IDs in the file</li>
              <li>Check all required fields are filled</li>
              <li>Verify numeric fields don't contain text or currency symbols</li>
              <li>For price lists, ensure hospital is selected first</li>
            </ul>
          </div>

          <div className="border-l-4 border-green-400 pl-4">
            <h4 className="font-semibold text-green-900 mb-2">Hospital Has Negative Balance</h4>
            <p className="text-sm mb-2"><strong>Problem:</strong> Hospital balance shows negative "Net Outstanding".</p>
            <p className="text-sm"><strong>Solution:</strong> This is normal when paid claims exceed deposits. Add more deposits in Admin Panel → Deposits tab to bring balance positive.</p>
          </div>
        </>
      )}

      <div className="border-l-4 border-gray-400 pl-4">
        <h4 className="font-semibold text-gray-900 mb-2">Auto-Logout Warning</h4>
        <p className="text-sm mb-2"><strong>Problem:</strong> System shows inactivity warning.</p>
        <p className="text-sm"><strong>Solution:</strong> The system auto-logs out after 15 minutes of inactivity for security. Any activity (clicks, typing) resets the timer. If you see the warning, interact with the page to stay logged in.</p>
      </div>
    </div>
  </>
);
